import { useQueries } from '@tanstack/react-query';

import {
  getClosureRequest,
  closureRequestStatuses,
} from '@/features/gdpr/partnerClosure';
import { useGetPartnerHierarchy } from '@/features/lp-village/partners/api/getPartnerHierarchy';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

export const useGetOrganizationChildrenStatus = (
  partnerId: string,
  enabled: boolean
) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');
  const { data: hierarchy } = useGetPartnerHierarchy(partnerId, { enabled });

  const children = hierarchy?.children ?? [];
  const hasArchivedChildren = children.some((c) => c.archived);

  const closureResults = useQueries({
    queries: children.map((child) => ({
      queryKey: ['partners', child.id, 'closure-request'],
      queryFn: () => getClosureRequest({ partnerId: child.id, makeRequest }),
      enabled: !!child.id,
    })),
  });

  const hasAnonymizedChildren = closureResults.some(
    (result) => result.data?.status === closureRequestStatuses.Anonymized
  );

  return { hasArchivedChildren, hasAnonymizedChildren };
};
